window.addEventListener('load', () => {
    let btnLogin = document.querySelector('.js-fb-pixel-login');
    let registerBtn = document.querySelector('.js-fb-pixel-register');
    let enterContest = document.querySelector('.js-fb-pixel-enter-contest');
    let uploadReceiptBtn = document.querySelector('.js-fb-pixel-upload-receipt');
    let sendBtn = document.querySelector('.js-fb-pixel-send');

    btnLogin && btnLogin.addEventListener('click', function (e) {
        if (typeof fbq === 'function') {
            fbq('track', 'Buton-Autentificare');
        }
    });
    registerBtn && registerBtn.addEventListener('click', function (e) {
        if (typeof fbq === 'function') {
            fbq('track', 'Buton-CreareCont');
        }
    });
    enterContest && enterContest.addEventListener('click', function (e) {
        if (typeof fbq === 'function') {
            fbq('track', 'Buton-IntraInConcurs');
        }
    });
    uploadReceiptBtn && uploadReceiptBtn.addEventListener('click', function (e) {
        if (typeof fbq === 'function') {
            fbq('track', 'Buton-IncarcaBon');
        }
    });
    sendBtn && sendBtn.addEventListener('click', function (e) {
        if (typeof fbq === 'function') {
            fbq('track', 'Buton-Trimite');
        }
    });
});